
export const paginationOptions = {
    rowsPerPageText: 'Lignes par page:',
    rangeSeparatorText: 'sur',
    noRowsPerPage: false,
    selectAllRowsItem: false,
    selectAllRowsItemText: 'Tous'
};

export const customHeader = {
    subHeader: {
        style: {
            display: 'flex',
            justifyContent: 'flex-start',
            padding: '16px',
        },
    },
    headRow: {
        style: {
            minHeight: "40px",
            backgroundColor: "#F7F7F7",
            fontWeight: 'bold'
        },
    },
};